import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../../services/modal.service';

import { showErrorMessage } from '../../../utils/utils';
import { CampaignYearPipe } from '../../../pipes/campaignYear.pipe';
import { CampaignStatusPipe } from '../../../pipes/campaignStatus.pipe';
import { Page } from '../../../models/page.model';
import { ZSNCampaign, ZSNCampaignConfiguration } from '../../../models/zsn.model';
import { ZSNService } from '../../../services/zsn.service';
import { ZSNCampaignConfigurationEditComponent } from './campaign-config-edit.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'zsn-campaigns-cmp',
  templateUrl: 'campaigns.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, ZSNCampaignConfigurationEditComponent, CampaignYearPipe, CampaignStatusPipe, TranslatePipe, FormsModule, PaginationModule],
  providers: [ZSNService],
})
export class ZSNCampaignComponent implements OnInit, AfterViewInit {
  error: any;

  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public filter: string = '';

  constructor(
    private zsnService: ZSNService,
    private modal: ModalService,
    private router: Router,
  ) {}

  getCampaignsPaginated(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: string) {
    this.zsnService
      .getPageCampaigns(pageIndex, this.itemsPerPage, sortColumnName, sortColumnOrder, filter)
      .subscribe((page) => this.handlePage(page));
  }

  handlePage(page: Page<ZSNCampaign>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
  }

  addCampaignConfiguration(campaign: ZSNCampaign) {
    this.router.navigate(['/orders', 'zsn', 'admin', 'new', campaign.id]);
  }

  deleteCampaignConfiguration(config: ZSNCampaignConfiguration, event: any) {
    event.stopPropagation();
    // FIXME traiter les erreurs
    this.zsnService.deleteCampaignConfiguration(config).subscribe(
      (res) => {
        this.onChangeTable();
      },
      (error) => this.handleError(error, 'Impossible de supprimer la configuration'),
    );
  }

  handleError(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      console.error(error);
      showErrorMessage(this.modal, msg);
    }
  }

  editCampaignConfiguration(config: ZSNCampaignConfiguration, event: any) {
    this.router.navigate(['/orders', 'zsn', 'admin', 'edit', config.id]);
  }

  ngOnInit() {
    this.onChangeTable();
  }

  ngAfterViewInit() {}

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    const pageNumber = page.page;
    this.getCampaignsPaginated(pageNumber, null, null, this.filter);
  }
}
